import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { DirtyProgramCompletion } from '../ProgramCompletion/ProgramCompletion';

const ProgramSaveWarning: React.FC<{ programs: DirtyProgramCompletion[] }> = (props) => {
  const { programs } = props;
  const programData = programs.map(
    (program: DirtyProgramCompletion) => `${program.programName} at ${program.academicPartnerName}`
  );

  const renderSeparator = (index: number, arrayLength: number) => {
    if (arrayLength === 1) {
      return null;
    }
    if (arrayLength === 2 && index === 0) {
      return ' and ';
    }
    if (arrayLength > 2 && index === arrayLength - 2) {
      return ', and ';
    }
    if (arrayLength > 2 && index !== arrayLength - 1) {
      return ', ';
    }
  };

  const programList = programData.map((program: string, index: number) => {
    return (
      // eslint-disable-next-line react/no-array-index-key
      <span key={index}>
        <strong className='fontWeight--700'>{program}</strong>
        {renderSeparator(index, programData.length)}
      </span>
    );
  });

  return (
    <Typography variant='body1' data-testid='program-save-warning'>
      The completed program information for {programList} will not be editable after you save it. Do
      you want to continue?
    </Typography>
  );
};

export default ProgramSaveWarning;
